import { Button, DialogActions } from "@mui/material";
import {
  PickersActionBarProps,
  usePickerActionsContext,
  usePickerTranslations,
} from "@mui/x-date-pickers";
import { FC } from "react";

interface ICustomMuiPickersActionBar extends PickersActionBarProps {
  customOnAccept: () => void;
  customOnCancel: () => void;
}

export const CustomMuiPickersActionBar: FC<ICustomMuiPickersActionBar> = ({
  customOnAccept,
  customOnCancel,
  actions,
  ...other
}) => {
  const translations = usePickerTranslations();
  const { acceptValueChanges, cancelValueChanges } = usePickerActionsContext();

  const onCancelHandler = (): void => {
    cancelValueChanges();
    customOnCancel();
  };

  const onAcceptHandler = (): void => {
    acceptValueChanges();
    customOnAccept();
  };

  return (
    <DialogActions {...other}>
      <Button onClick={onCancelHandler}>
        {translations.cancelButtonLabel}
      </Button>
      <Button onClick={onAcceptHandler}>{translations.okButtonLabel}</Button>
    </DialogActions>
  );
};
